import { createSlice, createAction } from '@reduxjs/toolkit';
import initialState from '../../../domain/entities/indicators';

const fetchIndicators = createAction('fetchIndicators');

function fetchIndicatorsSuccess(state, action) {
  const { data } = action.payload;
  state.successFetching = true;
  state.errorFetching = false;
  state.indicators = data;
}

function fetchIndicatorsError(state) {
  state.successFetching = false;
  state.errorFetching = true;
  state.indicators = [];
}

const indicatorsReducer = createSlice({
  name: 'indicators',
  initialState,
  reducers: {
    fetchIndicatorsSuccess,
    fetchIndicatorsError,
  },
});

export const indicatorsActions = {
  ...indicatorsReducer.actions,
  fetchIndicators,
};

export default indicatorsReducer.reducer;
